/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';



am4core.addLicense("CH208466903");
am4core.useTheme(am4themes_animated);


const arrDisplay = [
    { label: "จำนวนใบงาน", value: "1" },
    { label: "คะแนน", value: "2" },
]

const TopEmployee = (props) => {

    const { sBA, data, ImgChart } = props

    const [sTypeDisplay, setsTypeDisplay] = useState("1")

    const schema = yup.object().shape({
        oTypeDisplay: yupFormSchemas.object(`type display`, { required: false }),
    });

    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })


    useEffect(() => {
        form.setValue("oTypeDisplay", { label: "จำนวนใบงาน", value: "1" })
        if (data) {
            onRenderGraphPie(data.objNumberReq, 1)
        }

    }, [data])

    useEffect(() => {
        if (data) {
            if (sTypeDisplay == "1") {
                onRenderGraphPie(data.objNumberReq, 1)
            }
            else {
                onRenderGraphPie(data.objScore, 2)
            }
        }

    }, [sTypeDisplay])


    const onRenderGraphPie = (data, sID) => {

        let chart = am4core.create(`topEmp_${sID}`, am4charts.XYChart);
        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        
        let sFormFilter = form.getValues("oTypeDisplay")
        let Value = sFormFilter != null ? sFormFilter.label : "";
        let title = chart.titles.create();
        title.text = Value != "" ? "Top 5 Employee ("+Value+")" : "Top 5 Employee";
        title.fontSize = 16;
        title.marginBottom = 10;
        title.align = "center";
        title.fontWeight = '400';

        chart.paddingBottom = 30;

        chart.data = data;

        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "name";
        categoryAxis.renderer.grid.template.strokeOpacity = 0;
        categoryAxis.renderer.minGridDistance = 10;
        categoryAxis.renderer.labels.template.dy = 35;
        categoryAxis.renderer.tooltip.dy = 35;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        // valueAxis.renderer.inside = true;
        // valueAxis.renderer.labels.template.fillOpacity = 0.3;
        valueAxis.renderer.grid.template.strokeOpacity = 0;
        valueAxis.min = 0;
        valueAxis.cursorTooltipEnabled = false;
        valueAxis.renderer.baseGrid.strokeOpacity = 0;

        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "name";
        series.tooltipText = "{valueY.value}";
        series.tooltip.pointerOrientation = "vertical";
        series.tooltip.dy = - 6;
        series.columnsContainer.zIndex = 100;

        let columnTemplate = series.columns.template;
        columnTemplate.width = am4core.percent(50);
        columnTemplate.maxWidth = 66;
        columnTemplate.column.cornerRadius(60, 60, 10, 10);
        columnTemplate.strokeOpacity = 0;

        series.heatRules.push({ target: columnTemplate, property: "fill", dataField: "valueY", min: am4core.color("#e5dc36"), max: am4core.color("#5faa46") });
        series.mainContainer.mask = undefined;

        let cursor = new am4charts.XYCursor();
        chart.cursor = cursor;
        cursor.lineX.disabled = true;
        cursor.lineY.disabled = true;
        cursor.behavior = "none";

        let bullet = columnTemplate.createChild(am4charts.CircleBullet);
        bullet.circle.radius = 30;
        bullet.valign = "bottom";
        bullet.align = "center";
        bullet.isMeasured = true;
        // bullet.mouseEnabled = false;
        bullet.verticalCenter = "bottom";
        bullet.interactionsEnabled = false;

        // let hoverState = bullet.states.create("hover");
        let outlineCircle = bullet.createChild(am4core.Circle);
        outlineCircle.adapter.add("radius", function (radius, target) {
            let circleBullet = target.parent as any;
            return circleBullet.circle.pixelRadius + 10;
        })

        let image = bullet.createChild(am4core.Image);
        image.width = 60;
        image.height = 60;
        image.horizontalCenter = "middle";
        image.verticalCenter = "middle";
        image.propertyFields.href = "href";

        image.adapter.add("mask", function (mask, target) {
            let circleBullet = target.parent as any;
            return circleBullet.circle;
        })

        let previousBullet;
        chart.cursor.events.on("cursorpositionchanged", function (event) {
            var dataItem = series.tooltipDataItem as any;

            if (dataItem && dataItem.column) {
                var bullet = dataItem.column.children.getIndex(1);

                if (previousBullet && previousBullet != bullet) {
                    previousBullet.isHover = false;
                }

                if (previousBullet != bullet) {
                    var hs = bullet.states.getKey("hover");
                    hs.properties.dy = -bullet.parent.pixelHeight + 30;
                    bullet.isHover = true;
                    previousBullet = bullet;
                }
            }
        })

        setTimeout(() => {
            chart.exporting.getImage("png").then((data) => {
                let idDiv = 6;
                let obj = {} as any;
                let idx6 = ImgChart.findIndex(f => f.idDiv == idDiv);

                if (idx6 !== -1) {
                    ImgChart[idx6].imgBase64 = data;
                }
                else {
                    obj = {
                        id: 1,
                        nOrder: 1,
                        sDesc: "Div 6 top Five",
                        sName: "Top 5 Employee",
                        idDiv: 6,
                        imgBase64: data
                    }
                    props.exportImg && props.exportImg(obj);
                }

            });
        }, 2000);

    }

    return (
        <>
            <div className='div-border'>
                <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                    <Grid item xs={12}>
                        <Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center" >
                            <Grid item xs={12} sm={'auto'}>
                                <Typography style={{ fontWeight: 500 }}>กลุ่มตลาด: {sBA}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormProvider {...form}>
                                    <AutoCompleteSelect
                                        name="oTypeDisplay"
                                        options={arrDisplay}
                                        label={''}
                                        required={false}
                                        disableClearable={true}
                                        IsRadius={true}
                                        onChange={(e) => {
                                            setsTypeDisplay(e?.value)
                                        }}
                                    />
                                </FormProvider>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <div id='SatisFactiondiv6' style={{ padding: '8px' }}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                                <Grid item xs={12}>
                                    {
                                        sTypeDisplay == "1" ?
                                            <>
                                                <div id={`topEmp_1`} style={{ width: "100%", height: "400px" }}></div>
                                            </>
                                            :
                                            <>
                                                <div id={`topEmp_2`} style={{ width: "100%", height: "400px" }}></div>
                                            </>
                                    }
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default TopEmployee